import { render, staticRenderFns } from "./ShortUrl.vue?vue&type=template&id=516351cc&scoped=true&"
import script from "./ShortUrl.vue?vue&type=script&lang=js&"
export * from "./ShortUrl.vue?vue&type=script&lang=js&"
import style0 from "./ShortUrl.vue?vue&type=style&index=0&id=516351cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516351cc",
  null
  
)

export default component.exports